import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Check for token in URL parameters first, then localStorage with both possible keys
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get("token");
  const authToken = localStorage.getItem("authToken");
  const token = localStorage.getItem("token");

  const isAuthenticated = !!(urlToken || authToken || token);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
